/* eslint-disable react-hooks/exhaustive-deps */
import { urlLabel } from '@/enum/PermissionEnum';
import CRConsolidationReportViewer from '@/module/coporate-consolidation-report-viewer';
import CRReportViewer from '@/module/coporate-report-viewer';
import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

/**
 * Single entry point for preview download corporate reports.
 * - Default: CR Report (type not set)
 * - Consolidation: type=consolidated
 *
 * Example:
 * `project-cr?requestKey=...&hrEmail=...&type=consolidated`
 */
const PreviewDownloadCRRouter = (props) => {
  const query = new URLSearchParams(useLocation().search);
  const history = useHistory();

  const type = (query.get('type') || '').toLowerCase();
  const isConsolidated = type === 'consolidated' || type === 'consolidation';

  // Ensure base params exist (matches existing behavior)
  useEffect(() => {
    const requestKey =
      query.get('requestKey') || localStorage.getItem('requestKey');
    const hrEmail = (
      query.get('hrEmail') ||
      localStorage.getItem('hrEmail') ||
      ''
    ).replace(/ /g, '+');
    if (!hrEmail || !requestKey) {
      history.push(
        `/${urlLabel.previewDownloadCRReport}?requestKey=${localStorage.getItem(
          'requestKey'
        )}&hrEmail=${localStorage.getItem('hrEmail')}${
          isConsolidated ? '&type=consolidated' : ''
        }`
      );
    }
  }, [history, isConsolidated]);

  return isConsolidated ? (
    <CRConsolidationReportViewer {...props} />
  ) : (
    <CRReportViewer {...props} />
  );
};

export default PreviewDownloadCRRouter;
